import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import InputLabel from '@components/InputLabel/InputLabel';

/**
 * VITALL-styled label component for the routine form
 */
const Label = ({
  color = 'primary.main',
  ml = 0,
  mr = 0,
  ...props
}: AppointmentForm.LabelProps & {
  color?: string;
  ml?: number;
  mr?: number;
}) => {
  const { text } = props;
  return (
    <InputLabel
      label={text}
      style={{ width: 'auto', color, cursor: 'inherit', ml, mr }}
    />
  );
};

export default Label;
